import React from 'react';
import { Heart } from 'lucide-react';
import WhyPanel from './WhyPanel';

/**
 * RecoveryWhyPanel — thin wrapper over the shared <WhyPanel /> with
 * recovery-specific copy + color. Kept as a named component so the import
 * in Recovery.js stays semantic and any future recovery-only tweaks have a
 * clear home.
 */
const RecoveryWhyPanel = ({ insight, score, onActionClick }) => (
  <WhyPanel
    insight={insight}
    icon={Heart}
    color="#22d3ee"
    title={`WHY YOUR RECOVERY IS${score != null ? '' : ' WHERE IT IS'}`}
    score={score}
    testIdPrefix="recovery-why-panel"
    onActionClick={onActionClick}
    emptyMessage="I don't have enough signals yet to explain recovery. Log today's check-in (mood / sleep / body) and I'll show you exactly which levers are moving the needle."
  />
);

export default RecoveryWhyPanel;
